import { Component, OnInit } from '@angular/core';
import { RouteService } from '@services/route.service';

@Component({
  selector: 'gob-promo-page',
  templateUrl: './promo-page.component.html',
  styleUrls: ['./promo-page.component.css']
})
export class PromoPageComponent implements OnInit {

  constructor(public route: RouteService) { }

  ngOnInit(): void {
  }

}
